<script setup lang="ts">
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import Translator from "@/utils/common/Translator.ts";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import ErrorTooltip from "@/components/EditView/ErrorTooltip.vue";
import ColorUtils from "@/utils/common/ColorUtils.ts";
import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

const {compactMode, isUltra} = storeToRefs(useNamaFlagsStore());
const checkboxSize = computed(() => isUltra.value ? '30px' : compactMode.value ? '34px' : '40px');
const props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
const fieldUtil = new FieldWidgetUtil(props.presenter, props.fieldMetaData);

const boolean = fieldUtil.formattedValue();

function onUpdate(value: boolean) {
  fieldUtil.onPartialUserInput(value);
  fieldUtil.onUserInputFinished();
}
</script>

<template>
  <WidgetContainer
    :field="field"
    :entityType="presenter.entityType"
    :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
    :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
    title="&#8203;" :isInsideComposite="isInsideComposite">
    <template v-slot:widget>
      <q-checkbox :id="fieldId" ref="input"
                  :disable="fieldUtil.isFieldDisabled(forceEnableField)"
                  :label="!field.hasTitle && isInsideComposite ? '&#8203;' : Translator.translateTitledId(presenter.entityType!, field)"
                  :color="ColorUtils.getClosestQuasarColor(fieldUtil.getFieldStyle().backColor)"
                  :size="checkboxSize"
                  :data-field-id="fieldId"
                  class="nama-checkbox nama-checkbox-selected tw-text-sm tw-font-light tw-pe-3 compact:tw-pe-2 ultra:tw-pe-1 tw-rounded-sm"
                  :class="{ 'nama-checkbox-error tw-font-normal tw-text-red-700':props.presenter.fetchFieldErrorMsg(fieldId),
                  'tw-text-namaFontColor-label-light dark:tw-text-namaFontColor-label-dark':!props.presenter.fetchFieldErrorMsg(fieldId),
                   '':fieldUtil.isFieldDisabled(forceEnableField), 'hover:tw-text-blue-500':!fieldUtil.isFieldDisabled(forceEnableField)}"
                  :model-value="boolean" @update:model-value="onUpdate"
                  @keydown.enter="(e)=>$emit('navigateToNext',{keyboardEvent:e})"/>
      <ErrorTooltip v-if="presenter.fetchFieldErrorMsg(fieldId)" :error-msg="presenter.fetchFieldErrorMsg(fieldId)"/>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
